import { SORT_OPTIONS } from "@/utils/applicationConstants";
import { sharedService } from "@/modules/shared/store/services/shared-service";
import { RECEIVE_GET_VALUES_BASED_ON } from "@/redux/constants/values_based_on";

const DEFAULT_FILTERS = { page: 1, size: 30, sortBy: SORT_OPTIONS[0].id, searchTerm: "" };

const getValuesBasedOn = sharedService.injectEndpoints({
  endpoints: builder => ({
    getValuesBasedOn: builder.query({
      query: () => {
        const params = new URLSearchParams();
        Object.entries(DEFAULT_FILTERS).forEach(([k, v]) => { if (v) params.set(k, v); });
        return `parameters/values-based-on?${params}`;
      },
      transformResponse: response => response.items,
      providesTags: ["ValuesBasedOn"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch({ type: RECEIVE_GET_VALUES_BASED_ON, valuesBasedOn: data });
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetValuesBasedOnQuery } = getValuesBasedOn;

